import { Box, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { AppBarProps, AppBar as RaAppBar, useSidebarState, useTranslate } from 'react-admin';

import { BrandAwareLogo, EnvIndicator, Version } from '@sh4res/bo-common/components';
import { getTheme } from '@sh4res/bo-common/theme';
import { getAppBarBackgroundStyle, getTitlePaddingStyle } from '@sh4res/bo-common/utils';

import { httpClient } from '@Utils/providers/dataProvider';

export function AppBar(props: AppBarProps) {
  const [isOpen] = useSidebarState();

  const appBarStyle = useMemo(
    () => getAppBarBackgroundStyle(isOpen) as React.CSSProperties,
    [isOpen],
  );
  const titleStyle = useMemo(() => getTitlePaddingStyle(isOpen) as React.CSSProperties, [isOpen]);
  return (
    <>
      <RaAppBar {...props} userMenu={false} sx={appBarStyle} toolbar={<div />}>
        {isOpen && (
          <Box sx={{ paddingTop: '10px', paddingLeft: '11px' }}>
            <BrandAwareLogo width={120} />
            <EnvIndicator />
          </Box>
        )}
        <Typography variant="h1" id="react-admin-title" sx={titleStyle}></Typography>
        {getTheme() === 'axa' && <AxaHeader />}
        <Box flex={1} />
      </RaAppBar>
      <Version httpClient={httpClient} />
    </>
  );
}

const AxaHeader = () => {
  const translate = useTranslate();
  const theme = useTheme();

  return (
    <>
      <Typography
        variant="h2"
        id="partner-title"
        sx={{
          fontFamily: 'PublicoHeadline',
          fontWeight: 700,
          fontSize: '23px',
          lineHeight: '28px',
          color: theme.palette.primary.main,
          minWidth: 'max-content',
          padding: '7px',
        }}>
        {translate('app_bar.axa_header')}
      </Typography>
    </>
  );
};
